import { useState, useEffect, useRef } from "react";

const TaskDescriptionPopup = ({
    showDescriptionPopup, currentTask, CircleDot, textareaRef, editData, handleInput, CircleStop,
    setEditData, Calendar, setShowDatePicker, showDatePicker, Flag, TaskPriority, Users, TaskEmployees,
    ClockFading, TaskTimeline, TaskDetails, X, handleClosePopup, CommentsSection, handleAddComment,
    setCommentText, commentText, setCommentEmployees, SendHorizontal, getStatusColor, SmartDatePicker,
    employees, timelineArray, commentEmployees, Input, currentUser, projects, mergedComments,
    formatStatusLabel, runningTaskId, statuses, isSaving
}) => {


    const [showStatus, setShowStatus] = useState(false);
    const statusRef = useRef(null);
    const popupRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (statusRef.current && !statusRef.current.contains(event.target)) {
                setShowStatus(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    const [isBelow540, setIsBelow540] = useState(window.innerWidth < 540);

    useEffect(() => {
        const handleResize = () => {
            setIsBelow540(window.innerWidth < 540);
        };

        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    return (
        <>

            {showDescriptionPopup && currentTask && editData.title && (
                <div
                    className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[999999999999]"
                    onPointerDown={(e) => {
                        if (popupRef.current && !popupRef.current.contains(e.target)) {
                            handleClosePopup();
                        }
                    }}
                >
                    <div
                        ref={popupRef}
                        className="bg-white rounded p-2 sm:p-6 w-[90%] h-[90vh] shadow-lg relative overflow-y-auto max-w-[90%] animate-scaleIn">

                        {isSaving && (
                            <div className="absolute inset-0 bg-white/70 flex items-center justify-center z-[9999]">
                                <div className="flex flex-col items-center gap-2">
                                    <div className="w-8 h-8 border-4 border-gray-300 border-t-black rounded-full animate-spin"></div>
                                    <span className="text-sm text-gray-600">Saving...</span>
                                </div>
                            </div>
                        )}

                        <div className="w-full mx-auto flex justify-between h-[100%] border border-gray-300">
                            <div className="w-[100%] lg:w-[70%] border-r border-gray-400 p-[10px] xl:p-[20px] overflow-auto scrollbar-hide">
                                <h2 className="mb-4 text-gray-500 font-light inline-flex gap-[5px] items-center justify-center text-[12px] md:text-[16px] p-[5px] w-[80px] border border-gray-300 rounded-md">
                                    <CircleDot size={12} /> Task
                                </h2>
                                <textarea
                                    ref={textareaRef}
                                    className="w-full rounded px-2 py-1 mb-4 text-[16px] sm:text-[20px] md:text-[25px] border-gray-400 outline-none focus:ring-1 focus:ring-gray-200 resize-none overflow-hidden"
                                    value={editData.title}
                                    onChange={handleInput}
                                    rows={1}
                                    placeholder="Enter text..."
                                />

                                <div className="text-[14px]">
                                    <div className="flex items-center gap-3 xs:gap-[50px] mb-4">
                                        <span className="flex items-center gap-[5px] min-w-[100px] zs:min-w-[150px]">
                                            <CircleStop className="w-3 h-3 sm:w-4 sm:h-4" />
                                            <span className="font-medium text-[12px] sm:text-[16px]  text-gray-700">Status</span>
                                        </span>

                                        <div
                                            className="relative cursor-pointer"
                                            onClick={() => setShowStatus((prev) => !prev)}
                                            ref={statusRef}
                                        >
                                            {/* Status Button */}
                                            <span
                                                className={`px-3 py-1.5 rounded-lg text-[12px] sm:text-[14px] uppercase transition-colors duration-200 shadow-sm ${getStatusColor(
                                                    editData.status || ""
                                                )} hover:brightness-90`}
                                            >
                                                <span className="text-[12px] sm:text-[15px] md:text-[16px]">
                                                    {editData.status ? formatStatusLabel(editData.status) : "-"}
                                                </span>

                                            </span>

                                            {/* Dropdown */}
                                            {showStatus && (
                                                <div
                                                    className="
        absolute top-full left-[-67px] zx:left-0 mt-2
        w-44 max-h-56
        bg-white
        border border-gray-200
        rounded-xl
        shadow-xl
        overflow-hidden   
        overflow-y-auto
        z-50
        flex flex-col
        animate-fadeIn
      "
                                                >
                                                    {statuses.map((status) => {
                                                        const isActive = editData.status === status;
                                                        return (
                                                            <div
                                                                key={status}
                                                                onClick={(e) => {
                                                                    e.stopPropagation();
                                                                    setEditData((prev) => ({ ...prev, status }));
                                                                    setShowStatus(false);
                                                                }}
                                                                className={`
              px-4 py-2.5
              md:px-3 text-[11px] md:text-sm
              cursor-pointer
              flex items-center justify-between
              transition-all
              ${isActive
                                                                        ? "bg-gray-800 text-white font-semibold"
                                                                        : "text-gray-700 hover:bg-gray-100"
                                                                    }
            `}
                                                            >
                                                                {formatStatusLabel(status)}
                                                                {isActive && <span className="text-xs opacity-80 ml-2">✓</span>}
                                                            </div>
                                                        );
                                                    })}
                                                </div>
                                            )}
                                        </div>
                                    </div>

                                    <div className="flex items-center gap-3 xs:gap-[50px] mb-4 date-popup">
                                        <span className="flex items-center gap-[5px] min-w-[100px] zs:min-w-[150px]">
                                            <Calendar className="w-3 h-3 sm:w-4 sm:h-4" />
                                            <span className="font-medium text-[12px] sm:text-[16px]  text-gray-700">Dates</span>
                                        </span>

                                        <div className="relative date-filter">
                                            <SmartDatePicker
                                                placement="bottom"
                                                align={isBelow540 ? "right" : "left"}
                                                open={showDatePicker === "edit"}
                                                setOpen={(isOpen) => setShowDatePicker(isOpen ? "edit" : null)}
                                                selected={editData.dueDate ? new Date(editData.dueDate) : null}
                                                setSelected={(d) => {
                                                    const finalDate = d ? new Date(d) : null;

                                                    setEditData(prev => ({
                                                        ...prev,
                                                        dueDate: finalDate,
                                                    }));
                                                }}
                                            />
                                        </div>
                                    </div>

                                    <div className="flex items-center gap-3 xs:gap-[50px] mb-4">
                                        <span className="flex items-center gap-[5px] min-w-[100px] zs:min-w-[150px]">
                                            <Flag className="w-3 h-3 sm:w-4 sm:h-4" />
                                            <span className="font-medium text-[12px] sm:text-[16px]  text-gray-700">
                                                Priority
                                            </span>
                                        </span>
                                        <div className="relative">
                                            <TaskPriority
                                                value={editData.priority}
                                                onChange={(level) =>
                                                    setEditData((d) => ({
                                                        ...d,
                                                        priority: level,
                                                    }))
                                                }
                                            />
                                        </div>
                                    </div>
                                    <div className="flex items-center gap-3 xs:gap-[50px] mb-4">
                                        <span className="flex items-center gap-[5px] min-w-[100px] zs:min-w-[150px]">
                                            <Users className="w-3 h-3 sm:w-4 sm:h-4" />
                                            <span className="font-medium text-[12px] sm:text-[16px]  text-gray-700">
                                                Assigned
                                            </span>
                                        </span>
                                        <div className="relative flex items-center gap-[10px]">
                                            <TaskEmployees
                                                selected={editData.assignedEmployees}
                                                onChange={(arr) =>
                                                    setEditData((d) => ({
                                                        ...d,
                                                        assignedEmployees: arr,
                                                    }))
                                                }
                                                employees={employees}
                                                align={isBelow540 ? "right" : "left"}
                                            />
                                            {editData.assignedEmployees
                                                .map(
                                                    (id) =>
                                                        employees.find((e) => e._id === id)?.fullName ||
                                                        employees.find((e) => e._id === id)?.username
                                                )
                                                .filter(Boolean)
                                                .join(", ")}
                                        </div>
                                    </div>
                                    <div className="flex items-center gap-3 xs:gap-[50px] mb-4">
                                        <span className="flex items-center gap-[5px] min-w-[100px] zs:min-w-[150px]">
                                            <ClockFading className="w-3 h-3 sm:w-4 sm:h-4" />
                                            <span className="font-medium text-[12px] sm:text-[16px]  text-gray-700">
                                                Track time
                                            </span>
                                        </span>
                                        <TaskTimeline
                                            task={{
                                                ...currentTask,
                                                timeline: timelineArray,
                                            }}
                                            user={currentUser}
                                            showControls={false}
                                            runningTaskId={runningTaskId}
                                            showDropDown={true}
                                            employee={employees}
                                        />
                                    </div>
                                </div>
                                <div className="w-full mx-auto mt-10">
                                    <TaskDetails editData={editData} setEditData={setEditData} user={currentUser}
                                        TaskEmployees={TaskEmployees} employees={employees} />
                                </div>
                                <button
                                    onClick={handleClosePopup}
                                    className="
    absolute top-1 right-1
    flex items-center justify-center
    w-8 h-8
    rounded-full
    bg-gray-200 hover:bg-gray-300
    text-gray-700
    focus:outline-none focus:ring-2 focus:ring-gray-400
    transition-colors
  "
                                    aria-label="Close popup"
                                >
                                    <X size={16} strokeWidth={2.5} />
                                </button>

                            </div>
                            <div className="w-[30%] hidden lg:block">
                                <div className="p-[5px] xl:p-[10px] border-b border-gray-400 text-sm font-medium">
                                    Activity
                                </div>
                                <div className="p-[5px] xl:p-[5px] text-[12px] bg-[#f9f9f9]">
                                    <CommentsSection projects={projects} comments={mergedComments || []} />
                                    <div className="w-full flex items-end gap-2 bg-gray-50 border rounded-xl p-2 sm:p-3 shadow-sm">
                                        <div className="flex items-center">
                                            <TaskEmployees
                                                employees={employees}
                                                selected={commentEmployees}
                                                onChange={(arr) => {
                                                    setCommentEmployees(arr);
                                                }}
                                                placement="top"
                                                align="left"
                                            />
                                        </div>

                                        <div className="flex items-end gap-2 flex-1">
                                            <textarea
                                                className="flex-1 border border-gray-300 rounded-lg px-2 py-1 sm:px-3 sm:py-2 text-sm
  focus:outline-none focus:ring-2 focus:ring-blue-400
  placeholder-gray-400 bg-white resize-none  min-h-[50px] overflow-y-auto"

                                                placeholder="Write a comment..."
                                                value={commentText}
                                                rows={1}
                                                onChange={(e) => setCommentText(e.target.value)}

                                                onKeyDown={(e) => {
                                                    if (e.key === "Enter" && !e.shiftKey && commentText.trim()) {
                                                        e.preventDefault();
                                                        handleAddComment();
                                                    }
                                                }}
                                            />

                                            <button
                                                className=" h-7 w-7 sm:h-9 sm:w-9 flex items-center justify-center
             bg-blue-600 text-white rounded-md
             hover:bg-blue-700 transition disabled:opacity-50"
                                                disabled={!commentText.trim()}
                                                onClick={() => {
                                                    if (commentText.trim() !== "") handleAddComment();
                                                }}
                                            >
                                                <SendHorizontal size={18} />
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default TaskDescriptionPopup;
